<!-- When product is INSOLES -->
<div class="address-form" *ngIf="productName === 'PRODUCTS.INSOLES' && token && token !== null && token !== ''">
    <iframe id="design_engine" width="100%" sandbox="allow-same-origin allow-scripts" [src]="iframeUrl"></iframe>
    <div class="design-engine-logo"><img style="max-height: 70px; width: auto;" src="{{customLogo}}"></div>
</div>


<p-dialog *ngIf="productName === 'PRODUCTS.INSOLES'" header="{{'SCANS_PAID' | translate}}" [(visible)]="isScanPopup"
    [modal]="true" [style]="{ width: '50vw', minHeight: '200px' }" [draggable]="false" [resizable]="false">
    <div class="address-form">
        <form [formGroup]="scanForm">
            <div class="form-group">
                <label for="leftFoot">{{ "LEFT_FOOT" | translate }}</label>

                <div style="display: flex;">

                    <select class="form-select" formControlName="leftFoot">
                        <option value="" disabled selected>{{ "SELECT_LEFT_FOOT" | translate}}</option>
                        <ng-container *ngFor="let file of scanFiles">
                            <option [ngValue]="file">{{ file.name }}</option>
                        </ng-container>
                    </select>

                    <p-dropdown [options]="scanModes" formControlName="leftFootScanMode" placeholder="Select Scan Mode"
                        appendTo="body"></p-dropdown>

                </div>

            </div>


            <div class="form-group">
                <label for="rightFoot">{{ "RIGHT_FOOT" | translate }}</label>
                <div style="display: flex;">

                    <select class="form-select" formControlName="rightFoot">
                        <option value="" disabled selected>{{ "SELECT_RIGHT_FOOT" | translate }}</option>
                        <ng-container *ngFor="let file of scanFiles">
                            <option [ngValue]="file">{{ file.name }}</option>
                        </ng-container>
                    </select>

                    <p-dropdown [options]="scanModes" formControlName="rightFootScanMode" placeholder="Select Scan Mode"
                        appendTo="body"></p-dropdown>

                </div>


            </div>

            <div class="form-group" *ngIf="jsonFiles && jsonFiles.length > 0">
                <label for="design">Design</label>
                <select class="form-select" formControlName="design">
                    <option value="" disabled selected>Select Design</option>
                    <ng-container *ngFor="let file of jsonFiles">
                        <option [ngValue]="file">{{ file.name }}</option>
                    </ng-container>
                </select>
            </div>

            <div class="text-center mt-3">
                <p-button [loading]="loading" [label]="buttonLabel" styleClass="p-button-raised p-button-sm"
                    (click)="loginofLeopoly()" [disabled]="!isDesignEngineReady"></p-button>
            </div>
        </form>
    </div>
</p-dialog>

<!-- Subscription Modal -->
<app-modal-subscription-plan [productInput]="selectedProduct"></app-modal-subscription-plan>

<!-- When product is AFO -->
<div class="address-form" *ngIf="productName === 'PRODUCTS.AFO' && afoToken && afoToken !== null && afoToken !== ''">
    <iframe id="design_engine_afo" width="100%" sandbox="allow-same-origin allow-scripts" [src]="iframeAfoUrl"></iframe>
    <!-- <div class="design-engine-logo"><img style="max-height: 70px; width: auto;" src="{{customLogo}}"></div> -->
</div>

<p-dialog *ngIf="productName === 'PRODUCTS.AFO'" header="{{'SCANS_PAID' | translate}}" [(visible)]="isScanPopup"
    [modal]="true" [style]="{ width: '50vw', minHeight: '200px' }" [draggable]="false" [resizable]="false">
    <div class="address-form">
        <form [formGroup]="afoScanForm">
            <div class="form-group">
                <label for="file">File</label>

                <div style="display: flex;">

                    <select class="form-select" formControlName="file">
                        <option value="" disabled selected>{{ "SELECT_FILE" | translate}}</option>
                        <ng-container *ngFor="let file of scanFiles">
                            <option [ngValue]="file">{{ file.name }}</option>
                        </ng-container>
                    </select>

                </div>

            </div>

            <div class="text-center mt-3">
                <p-button [loading]="loading" [label]="buttonLabel" styleClass="p-button-raised p-button-sm"
                    (click)="loginofLeopolyAFO()" [disabled]="!isDesignEngineReady"></p-button>
            </div>
        </form>
    </div>
</p-dialog>

<!-- When product is Spinal Brace -->
<div class="address-form"
    *ngIf="productName === 'PRODUCTS.SPINAL_BRACE' && spinalBraceToken && spinalBraceToken !== null && spinalBraceToken !== ''">
    <iframe id="design_engine_spinal_brace" width="100%" sandbox="allow-same-origin allow-scripts"
        [src]="iframeSpinalBraceUrl"></iframe>
    <!-- <div class="design-engine-logo"><img style="max-height: 70px; width: auto;" src="{{customLogo}}"></div> -->
</div>

<p-dialog *ngIf="productName === 'PRODUCTS.SPINAL_BRACE'" header="{{'SCANS_PAID' | translate}}"
    [(visible)]="isScanPopup" [modal]="true" [style]="{ width: '50vw', minHeight: '200px' }" [draggable]="false"
    [resizable]="false">
    <div class="address-form">
        <form [formGroup]="spinalBraceScanForm">
            <div class="form-group">
                <label for="file">File</label>

                <div style="display: flex;">

                    <select class="form-select" formControlName="file">
                        <option value="" disabled selected>{{ "SELECT_FILE" | translate}}</option>
                        <ng-container *ngFor="let file of scanFiles">
                            <option [ngValue]="file">{{ file.name }}</option>
                        </ng-container>
                    </select>

                </div>

            </div>

            <div class="text-center mt-3">
                <p-button [loading]="loading" [label]="buttonLabel" styleClass="p-button-raised p-button-sm"
                    (click)="loginofLeopolySpinalBrace()" [disabled]="!isDesignEngineReady"></p-button>
            </div>
        </form>
    </div>
</p-dialog>